export default "__VITE_ASSET__CHNxTlVZ__"